import React, { useEffect, useState } from "react";
import fetchInactiveRecruiterDashboard from "../../services/fetchInactiveRecruiterDashboard";
import moment from "moment";
import Button from "../../components/Button";
import { toast, ToastContainer } from "react-toastify";
import ButtonContainer from "../../components/ButtonContainer";
import Heading from "../../components/Heading";
import FromToDatePicker from "../../components/FromToDatepicker";
import user from "../../store/user";

export default function InactiveRecruiterDashboard(param) {

  const [adminId, setAdminId] = useState(null);
  const [dateRange, setDateRange] = useState({
    startDate: moment()
      .subtract(1, "day")
      .startOf("day")
      .toDate(),
    endDate: moment()
      .startOf("day")
      .toDate(),
  });
  const [isLoading, setIsLoading] = useState(false);
  

  async function fetchData() {
    const startDate = moment(dateRange.startDate).format();
    const endDate = moment(dateRange.endDate).endOf("day").format();
    setIsLoading(true);
    try {
      const res = await fetchInactiveRecruiterDashboard(adminId, { startDate, endDate });
      
      // Create blob URL
      const url = window.URL.createObjectURL(new Blob([res.data]));
      
      // Create temporary link element
      const link = document.createElement('a');
      link.href = url;
      
      // Set filename with date range
      const filename = `inactive_recruiters_${moment(startDate).format('YYYY-MM-DD')}_to_${moment(endDate).format('YYYY-MM-DD')}.csv`;
      link.setAttribute('download', filename);
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up blob URL
      window.URL.revokeObjectURL(url);
    } catch(err) {
      console.log(err);
      toast.error('Something went wrong');
    }
    setIsLoading(false);
  }

  useEffect(() => {
    const getProfile = async () => {
        const profile = await user.getProfile();
        return profile;
    };

    getProfile().then(response => {
        setAdminId(response.id);
    }).catch(error => {
        window.location.href = process.env.REACT_APP_LOGIN_URL;
    })
}, []);

  return (
    <div>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable={false}
        pauseOnHover
      />
      <div className="page-heading">
        <Heading text="Inactive Company Dashboard" />
      </div>
      <div className="row">
        <ButtonContainer heading="Date:">
          <li>
            <div className="date-picker">
              <div className="form-group date">
                <div className="col-sm-6 left valueBox">
                  <FromToDatePicker
                    name="date"
                    startDate={dateRange.startDate}
                    endDate={dateRange.endDate}
                    maxDate={
                      Math.min(moment(dateRange.startDate).add(1, "month").toDate() ,  moment().toDate())
                    }
                    handleChangeStart={(e) => {
                      setDateRange({
                        startDate: e,
                        endDate:null
                      });                
                    }}
                    handleChangeEnd={(e) => {
                      setDateRange({
                        ...dateRange,
                        endDate: e,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </li>
          <li>
            <Button
              skin="dark"
              disabled={isLoading}
              text={isLoading ? "Downloading..." : "Download"}
              clickButton={fetchData}
            ></Button>
          </li>
        </ButtonContainer>
      </div>
    </div>
  );
};